<template>
  <v-container>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h2
          class="primary--text"
        >
          Mark Attendance for {{ balletClass.title }}
        </h2>
        <p>
          <b>{{ dancersForClass.length }} dancers attended</b>
          <br />{{ formattedDancersForClass }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex
        xs12
      >
        <form @submit.prevent="onAddDancersToClass">
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-autocomplete
                v-model="selectDancers"
                return-object
                chips
                deletable-chips
                multiple
                small-chips
                :items="dancers"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            pt-5
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-btn
                class="primary"
                :disabled="!formIsValid"
                type="submit"
              >
                Mark Attendance for {{ selectDancers.length }} Dancers
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: ['id'],
    data () {
      return {
        selectDancers: []
      }
    },
    computed: {
      balletClass () {
        return this.$store.getters.loadedBalletClass(this.id)
      },
      dancersForClass () {
        return this.$store.getters.loadedDancersforClass(this.balletClass.id)
      },
      dancers () {
        var dancerIds = this.dancersForClass.map(item => {
          return item.dancerId
        })
        return this.$store.getters.loadedDancers.map(item => {
          var alreadyAttended = dancerIds.includes(item.id)
          var dancerName = item.fullName
          if (alreadyAttended) {
            dancerName = dancerName.concat(' (already marked)')
          }
          return {
            text: dancerName,
            value: item.id,
            disabled: alreadyAttended
          }
        })
      },
      formattedDancersForClass () {
        if (Object.keys(this.dancersForClass).length === 0) {
          return 'None yet!'
        } else {
          return this.dancersForClass.map(item => {
            return item.dancerName
          }).sort().join(', ')
        }
      },
      formIsValid () {
        return true
      }
    },
    created () {
      this.$store.dispatch('getDancersForClass', this.id)
    },
    methods: {
      onAddDancersToClass () {
        if (!this.formIsValid) {
          return
        }
        var payload = {
          selectedDancers: this.selectDancers,
          balletClassId: this.balletClass.id,
          balletClassTitle: this.balletClass.title
        }
        this.$store.dispatch('markAttendance', payload)
      }
    }
  }
</script>
